import { FlexProps } from "@chakra-ui/react";
import { EditedPicture, PictureToEdit } from "../../common/PictureEditor";

export const MAX_BANNER_WIDTH = 1200 as const;
export const MAX_BANNER_ITEMS = 3 as const;
export const BANNER_ITEM_HEIGHT = 370 as const;

export type BannerEditorPictures = (EditedPicture | null)[];

export interface BannerEditorProps extends Omit<FlexProps, "onChange"> {
  onChange?: (images: BannerEditorPictures) => void;
  onLayoutChange?: (layout: number) => void;
  layout?: number;
  images?: (PictureToEdit | null)[];
  error?: string;
}
export interface BannerEditorCardProps extends FlexProps {
  imageCount: number;
}

export interface BannerEditorImagePreviewProps extends FlexProps {
  picture: PictureToEdit;
  onEdit: () => void;
  onDelete: () => void;
  isLoading?: boolean;
}
